<template>
  <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
    <v-card class="card">
      <v-card-title class="headline accent--text pb-4">
        {{ isEdit ? 'Редактировать' : 'Добавить' }} учебный период
      </v-card-title>

      <v-card-text outlined tile class="">
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-autocomplete
              v-model="submissionSession.semester"
              :items="dictionaries.semester"
              item-text="name"
              label="Семестр"
              placeholder="Выберите из списка"
              outlined
              rounded
              dense
              return-object
              @input="$v.submissionSession.semester.$touch()"
              @blur="$v.submissionSession.semester.$touch()"
              :error-messages="errorMessages.semester"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-combobox
              v-model="submissionSession.year"
              :items="dictionaries.year"
              item-text="name"
              item-value="name"
              label="Год"
              placeholder="Выберите или введите год"
              outlined
              rounded
              dense
              @keypress="keyHandler"
              @input=" $v.submissionSession.year.$touch()"
              @blur=" $v.submissionSession.year.$touch()"
              :error-messages="errorMessages.year"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-switch
              v-model="submissionSession.isActual"
              label="Активный период"
              color="success"
            />
          </v-col>

        </v-row>
      </v-card-text>

      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn text color="lightGrey" @click="closeModal">Отмена</v-btn>
        <v-btn
          :loading="loading || isSaving"
          :disabled="$v.$invalid"
          color="success"
          text
          @click="saveSubmissionSession"
        >
          {{ isEdit ? 'Сохранить' : 'Создать' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { SubmissionSession } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import { mapGetters } from "vuex"
import { yearApi } from '@/api'

export default {
  name: 'SubmissionSessionDialog',

  props: {
    loading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  data: () => ({
    submissionSession: new SubmissionSession(),
    isSaving: false,
  }),

  validations() {
    return {
      submissionSession: {
        semester: { required },
        year: { required },
        isActual: {}
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),

    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}
      Object.keys(this.$v.submissionSession.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.submissionSession[key])
      })
      return allErrors
    }
  },

  methods: {
    keyHandler(event) {
      const charCode = event.which ? event.which : event.keyCode

      if (charCode < 48 || charCode > 57) {
        event.preventDefault()
        return
      }

      if(event.target.value.length >=4 ){
        event.preventDefault()
      }

    },

     async saveSubmissionSession() {
      if (this.isSaving) return
      this.isSaving = true

      try {
        const dataToSend = { ...this.submissionSession }
        let yearValue = dataToSend.year

        const yearName = typeof yearValue === 'object' ? yearValue.name : yearValue
        
        let existingYear = this.dictionaries.year.find(y => y.name === yearName)
        
        if (!existingYear) {
          existingYear = await yearApi.create({ name: yearName })
        }

        dataToSend.year = existingYear
        this.$emit('saveSubmissionSession', dataToSend)

      } catch (error) {
        console.error('Ошибка:', error)
        this.$toastr('error', '', 'Не удалось сохранить')
      } finally {
        this.isSaving = false
      }
    },

    resetModal() {
      this.$v.$reset()
      this.submissionSession = new SubmissionSession()
    },

    closeModal() {
      this.submissionSession = new SubmissionSession()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(value) {
      this.submissionSession = value ? SubmissionSession.buildFromAPI(value) : new SubmissionSession()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important;
}
</style>